import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.padding || '20px'};
`;

export const Spinner = styled.div`
  width: ${props => props.size || '40px'};
  height: ${props => props.size || '40px'};
  border: 4px solid rgba(59, 130, 246, 0.1);
  border-left-color: #3b82f6;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const DotsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Dot = styled.div`
  width: ${props => props.size || '10px'};
  height: ${props => props.size || '10px'};
  margin: 0 4px;
  border-radius: 50%;
  background-color: #3b82f6;
  animation: ${pulse} 1.4s infinite ease-in-out;
  animation-delay: ${props => props.delay || '0s'};
`;

const LoadingText = styled.div`
  margin-top: 12px;
  font-size: 0.875rem;
  color: #64748b;
`;

const Loading = ({
  type = 'spinner',
  size,
  text,
  padding
}) => {
  const renderLoader = () => {
    switch (type) {
      case 'dots':
        return (
          <DotsContainer>
            <Dot size={size} delay="0s" />
            <Dot size={size} delay="0.2s" />
            <Dot size={size} delay="0.4s" />
          </DotsContainer>
        );
      case 'spinner':
      default:
        return <Spinner size={size} />;
    }
  };

  return (
    <LoadingContainer padding={padding}>
      {renderLoader()}
      {text && <LoadingText>{text}</LoadingText>}
    </LoadingContainer>
  );
};

export default Loading;
